import React, { useState } from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import {Header} from '../src/common/ui/Header';
import {Footer} from '../src/common/ui/Footer';
import {CopyrightModal} from '../src/common/ui/CopyrightModal'; // Импортируем модальное окно
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { pathAbout, pathClients, pathMain, pathProducts, pathRealAutomation, pathVacancy,pathConvoy } from './common/config/paths';
import { SectionAutomation } from './pages/MainPage/organoids/SectionAutomation';
import './common/assets/fonts/fonts.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css'; 
import { Products } from './pages/Products';
import { Vacancy } from './pages/Vacancy';
import { Convoy } from './pages/Convoy';
import { AboutCompany } from './pages/AboutCompany';
import { RealAutomation } from './pages/RealAutomation';
import { YMInitializer } from 'react-yandex-metrika';
import { CookieBanner } from './common/ui/CookieBanner/CookieBanner';

function App() {
  const EmptyContent = <div style={{minHeight: "calc(100vh - 167px)", paddingTop: "30px"}}>Empty content</div>
  
  // Состояние для управления модальным окном
  const [isCopyrightModalOpen, setIsCopyrightModalOpen] = useState(false);

  // Функции для открытия/закрытия модального окна
  const handleOpenCopyrightModal = () => {
    setIsCopyrightModalOpen(true);
  };

  const handleCloseCopyrightModal = () => {
    setIsCopyrightModalOpen(false);
  };

  return (
    <div className="App">
      <YMInitializer accounts={[89209310]} />
      <Header />
      <Switch>
        <Route exact path={pathClients} children  = { (props: any) => EmptyContent}></Route>
        <Route exact path={pathAbout} children  = { (props: any) => <AboutCompany/>}></Route>
        <Route exact path={pathProducts} children  = { (props: any) => <Products/>}></Route>
        <Route exact path={pathConvoy} children  = { (props: any) => <Convoy/>}></Route>
        <Route exact path={pathVacancy} children  = { (props: any) => <Vacancy/>}></Route>
        <Route exact path={pathRealAutomation} children  = { (props: any) => <RealAutomation/>}></Route>
        <Route path={pathMain} children ={ (props: any) => ( <SectionAutomation hash={props.location.hash}/>)}></Route> 
        <Route><Redirect to={pathMain}/></Route>
      </Switch>
      
      {/* Передаем функцию открытия модального окна в Footer */}
      <Footer onOpenCopyrightModal={handleOpenCopyrightModal} />
      
      {/* Модальное окно с информацией о правообладателе */}
      <CopyrightModal 
        isOpen={isCopyrightModalOpen} 
        onClose={handleCloseCopyrightModal} 
      />
      
      <CookieBanner />
      <ToastContainer />
    </div>
  );
}

export default App;